import React from 'react';

const Youtube = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#0F161E"
        fillRule="evenodd"
        d="M4.182 2A2.182 2.182 0 002 4.182v15.636C2 21.023 2.977 22 4.182 22h15.636A2.182 2.182 0 0022 19.818V4.182A2.182 2.182 0 0019.818 2H4.182zm12.495 5H7.323C5.488 7 4 8.314 4 9.935v4.13C4 15.686 5.488 17 7.323 17h9.354C18.512 17 20 15.686 20 14.065v-4.13C20 8.314 18.512 7 16.677 7zm-2.637 4.782a.24.24 0 010 .436l-3.688 1.703a.24.24 0 01-.34-.218v-3.406a.24.24 0 01.34-.218l3.688 1.703z"
        clipRule="evenodd"
       />
    </svg>
);

export default Youtube;
